
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'LocalizedProstateCancer',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Urology/LocalizedProstateCancer.vue